
import BusRatesTable from './BusRatesTable';
import './smallkey.css';
import { Helmet } from 'react-helmet';
import FAQKeyword from './FAQKeyword';
import Testimonials from './TestimonialKeyword';

function Bookpunetoratnagiricab() {



    const cardData =
    {
        keyword: 'Pune to Ratnagiri Taxi Services',
        heading: 'S9 Travels: Pune to Ratnagiri Taxi Services',
        headingDescription: 'S9 Travels offers reliable, comfortable, and affordable taxi services from Pune to Ratnagiri. Whether you are visiting for a peaceful beach getaway, a historical exploration, or a spiritual retreat, our well-maintained fleet and professional drivers ensure a smooth and hassle-free journey. Ratnagiri is approximately 330 km from Pune, and the journey takes around 6 to 7 hours by road. Enjoy a safe and comfortable ride with our top-notch amenities and customer-centric service.',

        top: 'Top Places to Visit in Ratnagiri with S9 Travels',

"topPlaces": [
    {
        "title": "Ratnagiri Fort",
        "description": "One of the most prominent historical landmarks in Ratnagiri, Ratnagiri Fort offers magnificent views of the Arabian Sea and the surrounding landscape. Built by the Marathas, the fort has a rich history and is a popular destination for history enthusiasts. The fort’s serene environment is perfect for exploring its ruins and enjoying the scenic beauty."
    },
    {
        "title": "Ganpatipule Temple",
        "description": "A short drive from Ratnagiri, Ganpatipule Temple is a significant pilgrimage site dedicated to Lord Ganesha. The temple houses an ancient self-originated idol of Lord Ganesha, attracting thousands of devotees. It is located near the picturesque Ganpatipule Beach, making it a perfect place for a spiritual visit."
    },
    {
        "title": "Ratnagiri Beach",
        "description": "The city of Ratnagiri itself is home to several beautiful beaches, with the Ratnagiri Beach being one of the most popular. The beach’s golden sands and peaceful environment offer a great spot to relax, take a walk, or enjoy the sunset. It’s a peaceful place perfect for unwinding."
    },
    {
        "title": "Bhatye Beach",
        "description": "Bhatye Beach is another serene beach near Ratnagiri, known for its quiet atmosphere and beautiful surroundings. It’s a great place to relax and enjoy nature, away from the crowds. The beach is also known for its spectacular sunset views."
    },
    {
        "title": "Jaigad Fort",
        "description": "Located about 25 km from Ratnagiri, Jaigad Fort is a coastal fort built by the Marathas. It provides spectacular views of the sea and the surrounding areas. The fort’s strategic location made it an important part of the region’s history. It's perfect for those interested in history and nature."
    },
    {
        "title": "Malgund Beach",
        "description": "A quiet and less crowded beach near Ganpatipule, Malgund Beach is an ideal spot for a peaceful retreat. Surrounded by lush greenery, it is a hidden gem for nature lovers and offers a relaxed environment for picnics and beach activities."
    },
    {
        "title": "Swayambhu Ganapati",
        "description": "Located close to Ganpatipule, the Swayambhu Ganapati Temple is an ancient shrine dedicated to Lord Ganesha. The idol here is considered self-originated, and the temple is nestled amidst scenic surroundings, offering visitors a tranquil and spiritual atmosphere."
    },
    {
        "title": "Kunkeshwar Temple",
        "description": "Located around 50 km from Ratnagiri, Kunkeshwar Temple is a historic and picturesque temple dedicated to Lord Shiva. Situated on the shores of the Arabian Sea, the temple offers both spiritual significance and breathtaking views. It is a beautiful blend of nature and religion."
    },
    {
        "title": "Tidal Waves Beach",
        "description": "Tidal Waves Beach, located on the way to Ganpatipule, offers a pristine and peaceful atmosphere. This less-crowded beach is perfect for those looking to enjoy the beauty of the sea without the usual tourist bustle. It’s a great spot for relaxation and sunset viewing."
    },
    {
        "title": "Shri Gajaban Maharaj Ashram",
        "description": "Situated in a peaceful location near Ratnagiri, the Shri Gajaban Maharaj Ashram offers a serene space for reflection, meditation, and spiritual practices. The ashram is surrounded by nature, providing a perfect retreat for those looking for inner peace and tranquility."
    }
],

"services": [
  {
    "name": "Pune to Ratnagiri Taxi",
    "description": "S9 Travels offers comfortable and reliable taxi services for your journey from Pune to Ratnagiri. Whether you're traveling for business, leisure, or a religious visit, enjoy a smooth and hassle-free ride with us. Book your Pune to Ratnagiri taxi today!"
  },
  {
    "name": "Pune to Ratnagiri Cab Booking",
    "description": "Booking a cab from Pune to Ratnagiri is easy with S9 Travels. Whether you prefer booking online or over the phone, we offer flexible options to ensure your journey is smooth and stress-free."
  },
  {
    "name": "Pune to Ratnagiri Taxi Service",
    "description": "Choose S9 Travels for a professional and reliable taxi service from Pune to Ratnagiri. Our experienced drivers and well-maintained vehicles guarantee a comfortable and pleasant journey every time."
  },
  {
    "name": "Pune to Ratnagiri One-Way Taxi",
    "description": "S9 Travels offers affordable and convenient one-way taxi services from Pune to Ratnagiri. Enjoy a direct, comfortable ride to your destination without any hassle, at a competitive price."
  },
  {
    "name": "Pune to Ratnagiri Round Trip",
    "description": "For a round trip from Pune to Ratnagiri, S9 Travels provides flexible options. Our round trip service ensures that your journey is comfortable and timely, whether you're traveling for business or leisure."
  },
  {
    "name": "Pune to Ratnagiri Cab Fare",
    "description": "S9 Travels offers transparent and affordable cab fares for your Pune to Ratnagiri trip. We ensure you get great value for your money with no hidden charges. Contact us for an accurate price estimate before booking your ride."
  },
  {
    "name": "Pune to Ratnagiri Car Hire",
    "description": "Looking to hire a car for your trip from Pune to Ratnagiri? S9 Travels offers flexible car hire services, giving you the freedom to travel at your own pace. Choose from a variety of vehicles to suit your needs."
  },
  {
    "name": "Pune to Ratnagiri Private Taxi",
    "description": "For a private and personalized experience, book a private taxi with S9 Travels. Our private taxi services from Pune to Ratnagiri offer comfort, flexibility, and privacy for your journey, ensuring a stress-free travel experience."
  },
  {
    "name": "Pune to Ratnagiri Efficient Taxi",
    "description": "S9 Travels provides Efficient Taxi services for those looking for a more budget-friendly option. Share the ride with others and enjoy a comfortable, convenient, and affordable taxi service from Pune to Ratnagiri."
  }
],


"tableData": [
  ["Book Pune To Ratnagiri Taxi", "Book Pune To Ratnagiri Cab Booking"],
  ["Book Pune To Ratnagiri Taxi Service", "Book Pune To Ratnagiri One-Way Taxi"],
  ["Book Pune To Ratnagiri Round Trip", "Book Pune To Ratnagiri Cab Fare"],
  ["Book Pune To Ratnagiri Car Hire", "Book Pune To Ratnagiri Private Taxi"],
  ["Book Pune To Ratnagiri Efficient Taxi"]
],
"whychoose": [
  {
    "WhyChooseheading": "Reliable and On-Time Service",
    "WhyChoosedescription": "At S9 Travels, we prioritize punctuality when traveling from Pune to Ratnagiri. Whether you're visiting for a business trip, family vacation, or a peaceful retreat, our drivers ensure timely pickups and drop-offs, making your journey effortless and on schedule."
  },
  {
    "WhyChooseheading": "Comfortable and Spacious Vehicles",
    "WhyChoosedescription": "We offer a selection of well-maintained vehicles for your trip to Ratnagiri. With spacious interiors, air conditioning, and comfortable seating, we guarantee a relaxed and enjoyable ride, no matter the distance."
  },
  {
    "WhyChooseheading": "Experienced and Professional Drivers",
    "WhyChoosedescription": "Our drivers are experienced professionals who are well-versed in handling long-distance routes to Ratnagiri. Their focus on your comfort and safety ensures a smooth and enjoyable journey from start to finish."
  },
  {
    "WhyChooseheading": "Affordable and Transparent Pricing",
    "WhyChoosedescription": "S9 Travels offers competitive and transparent pricing for your Pune to Ratnagiri trip. There are no hidden charges, and we provide a clear breakdown of costs upfront, ensuring that you know exactly what you're paying for."
  },
  {
    "WhyChooseheading": "Safe and Comfortable Journey",
    "WhyChoosedescription": "We take your safety seriously. All our vehicles are equipped with modern safety features like airbags, seat belts, and GPS tracking, so you can enjoy a secure and comfortable ride throughout the journey."
  },
  {
    "WhyChooseheading": "24/7 Availability",
    "WhyChoosedescription": "S9 Travels operates 24/7, allowing you to book your cab at any time, whether it’s an early morning departure or a late-night return. Our customer service team is always available to assist with your travel needs."
  },
  {
    "WhyChooseheading": "Hassle-Free Booking Process",
    "WhyChoosedescription": "Booking your Pune to Ratnagiri cab with S9 Travels is simple and convenient. You can make a reservation online via our website or mobile app, or reach out to our customer service team for personalized assistance."
  },
  {
    "WhyChooseheading": "Customized Travel Packages",
    "WhyChoosedescription": "Whether you're visiting Ratnagiri for tourism, business, or relaxation, we offer customized travel packages tailored to your needs. Share your preferences, and we’ll ensure a memorable and stress-free trip."
  }
]









    }




    const faqData = [
        [
          {
            question: 'How can I book a Pune to Ratnagiri cab with S9 Travels?',
            answer: 'Booking is easy! You can book your cab through our website or mobile app, or you can contact our customer service team for assistance with your booking.',
          },
          {
            question: 'Are the drivers experienced for long-distance travel?',
            answer: 'Yes, all our drivers are experienced professionals who are familiar with long-distance routes, ensuring a safe and smooth journey to Ratnagiri.',
          },
          {
            question: 'What types of vehicles are available for Pune to Ratnagiri travel?',
            answer: 'We offer a wide range of vehicles, including sedans, SUVs, and premium cars, all of which are well-maintained and designed for long-distance comfort.',
          },
          {
            question: 'How do I pay for my Pune to Ratnagiri cab rental?',
            answer: 'We provide multiple payment options, including cash, credit/debit cards, and online payments via our app, for your convenience.',
          },
          {
            question: 'Can I book a round trip from Pune to Ratnagiri?',
            answer: 'Yes, we can arrange round trips. Just provide your return details, and we will ensure a hassle-free and timely return trip.',
          },
          {
            question: 'Are there any extra charges for waiting or detours?',
            answer: 'Any additional charges, such as for waiting or detours, will be communicated to you upfront, ensuring complete transparency in pricing.',
          },
          {
            question: 'Can I hire a cab for sightseeing in Ratnagiri?',
            answer: 'Yes, we offer sightseeing tours in Ratnagiri. Explore the famous Ratnagiri Fort, Ganpatipule Beach, and other scenic attractions with our knowledgeable and professional drivers.',
          },
          {
            question: 'What is the luggage allowance for a Pune to Ratnagiri cab?',
            answer: 'Our vehicles can comfortably accommodate standard luggage. If you have more luggage or specific needs, please inform us during the booking process, and we will make the necessary arrangements.',
          },
          {
            question: 'Is S9 Travels available for corporate travel between Pune and Ratnagiri?',
            answer: 'Yes, we provide corporate travel services for business trips or group travels between Pune and Ratnagiri. We ensure reliable, punctual, and comfortable services for corporate clients.',
          },
          {
            question: 'Why should I choose S9 Travels for Pune to Ratnagiri travel?',
            answer: 'With S9 Travels, you’re guaranteed a comfortable, reliable, and affordable journey. Our professional drivers, well-maintained vehicles, and transparent pricing ensure a safe and smooth trip every time.',
          },
        ]
      ];
      
      const testimonialsData = [
        {
          name: 'Mr. Ramesh Shinde',
          designation: 'Customer',
          rating: [1, 1, 1, 1, 1],  
          text: '“I traveled to Ratnagiri with S9 Travels, and it was an amazing experience. The driver was friendly and professional, and the vehicle was clean and comfortable. I had a stress-free journey and highly recommend their services!”',
        },
        {
          name: 'Mrs. Priya Kulkarni',
          designation: 'Customer',
          rating: [1, 1, 1, 1, 1],  
          text: '“S9 Travels made our family trip to Ratnagiri unforgettable. The vehicle was spacious, and the driver was very courteous and knowledgeable about the route. We will definitely book with them again!”',
        },
      ];
      
      
    
    
    
    
    








    const contactData = {
        heading: `${cardData.keyword} Contact Number`,
        contactNumbers: [
            "+91 8850328441",
            "+91 9552526916",

        ],
        email: "booking@s9travels.com"
    };


    const Images = [
        {
            place: "/images/keyword/1.jpg",
            text: "Book Pune To Nashik Cab",
        },
        {
            place: "/images/keyword/2.jpg",
            text: "Book Pune To Ganpatipule Cab",
        },
        {
            place: "/images/keyword/3.jpg",
            text: "Book Pune To Ratnagiri Cab",
        },
        {
            place: "/images/keyword/4.jpg",
            text: "Book Pune To Devkund Cab",
        },
        {
            place: "/images/keyword/5.jpg",
            text: "Book Pune To Goa Cab Taxi",
        },
        {
            place: "/images/keyword/6.jpg",
            text: "Book Pune To Kolhapur Cab",
        },
        {
            place: "/images/keyword/7.jpg",
            text: "Book Pune To Lonavala Cab",
        },

        {
            place: "/images/keyword/8.jpg",
            text: "Book Pune To Alibaug Cab",
        },

        {
            place: "/images/keyword/9.jpg",
            text: "Book Pune To Aurangabad Cab",
        },
        {
            place: "/images/keyword/10.jpg",
            text: "Book Pune To Bhimashankar Cab",
        },

        {
            place: "/images/keyword/11.jpg",
            text: "Book Murud Janjira Cab From Pune",
        },
        {
            place: "/images/keyword/12.jpg",
            text: "Book Pune To Adlabs Imagica Cab",
        },

        {
            place: "/images/keyword/13.jpg",
            text: "Book Pune To Mahabaleshwar Cab",
        },

        {
            place: "/images/keyword/14.jpg",
            text: "Book Pune To Trimbakeshwar Cab",
        },
        {
            place: "/images/keyword/15.jpg",
            text: "Pune Mumbai Pune Round Trip",
        },
        {
            place: "/images/keyword/16.jpg",
            text: " Mumbai Pune Pickup Drop",
        },
        {
            place: "/images/keyword/17.jpg",
            text: "Outstation Cabs From Pune",
        },
        {
            place: "/images/keyword/18.jpg",
            text: "Bus Service In Pune",
        },
        {
            place: "/images/keyword/19.jpg",
            text: "12 Jyotirlinga Yatra From Pune",
        },
        {
            place: "/images/keyword/20.jpg",
            text: " Pune To Grishneshwar Cab Services",
        },
        
        {
            place: "/images/keyword/22.jpg",
            text: "Pune To Malshej Ghat Cab",
        },
        {
            place: "/images/keyword/23.jpg",
            text: "Pune To Pandharpur Cab Service",
        },
        {
            place: "/images/keyword/24.jpg",
            text: "Pune To Panhala Fort Cab Service",
        },
        {
            place: "/images/keyword/25.jpg",
            text: " Pune To Raigad Fort Cab Service",
        },
        {
            place: "/images/keyword/26.jpg",
            text: "Pune To Satara Kas Pathar Cab ",
        },
        {
            place: "/images/keyword/27.jpg",
            text: " Pune To Shirdi Cab Pickup Drop",
        },
    ];


    const images = [
        { src: "/images/ourfleet/1.jpg", alt: "Image 1" },
        { src: "/images/ourfleet/5.jpg", alt: "Image 1" },
        { src: "/images/ourfleet/2.jpg", alt: "Image 1" },
        { src: "/images/ourfleet/3.jpg", alt: "Image 1" },
        { src: "/images/ourfleet/4.jpg", alt: "Image 1" },
        { src: "/images/ourfleet/7.jpg", alt: "Image 1" },
        { src: "/images/ourfleet/8.jpg", alt: "Image 1" },
        { src: "/images/ourfleet/9.jpg", alt: "Image 1" },
        { src: "/images/ourfleet/6.jpg", alt: "Image 1" },

    ];


   
      
      
    const productSchema = {
        "@context": "https://schema.org",
        "@type": "Product",
        "name": "Book Pune To Ratnagiri Cab",
        "description": "Book Pune To Ratnagiri taxi services, one-way taxi, round trip, private taxi, Efficient Taxi, car hire, and affordable cab booking with S9 Travels. Choose from a variety of options including luxury taxis and reliable taxi fares for a comfortable ride to Ratnagiri.",
        "aggregateRating": {
          "@type": "AggregateRating",
          "bestRating": "5",
          "worstRating": "1",
          "ratingValue": "4.8",
          "ratingCount": "8569"
        }
      };
      
     
      


    return (
        <div>
          <Helmet>
        <title>Book Pune To Ratnagiri Cab | S9 Travels | Contact: +91 8850328441</title>
        <meta 
          name="description" 
          content="Book Pune To Ratnagiri taxi services, one-way taxi, round trip, private taxi, Efficient Taxi, and car hire with S9 Travels. Get the best fares for Pune to Ratnagiri cab booking, ensuring a safe, comfortable, and affordable ride." 
        />
        
        {/* Inject JSON-LD Schema */}
        <script type="application/ld+json">
          {JSON.stringify(productSchema)}
        </script>
      </Helmet>
<section className="page-title centred">
      <div className="bg-layer" style={{ backgroundImage: 'url(/images/background/page-title.jpg)' }}></div>
      <div className="auto-container">
        <div className="content-box">
        
          <h1>{cardData.keyword}</h1>
        </div>
      </div>
    </section>

      

            <section id="about" className="jarallax text-light">
                <div className="center-y relative text-center">
                    <div className="container">
                        <div className="row">
                            <div className="col-md-12 text-center">
                                {/* <h1 className='text-white'>{cardData.keyword}</h1> */}
                            </div>
                            <div className="clearfix"></div>
                        </div>
                    </div>
                </div>
            </section>

            <section>
                <div className="container-fluid" >
                    <div className="row ">
                        <div className="col-12 col-md-7 ">
                            <img src='/images/keyword/3.jpg' alt='img' />
                            <h3 className="py-1"
                                style={{
                                    color: '#322E77', // Red color for the title 
                                    textShadow: '5px 5px 10px rgba(255, 255, 255, 0.7)', // Light shadow effect
                                    fontWeight: 'bold'
                                }}


                            >{cardData.heading} </h3><p className='fw-bold '>{cardData.headingDescription}</p>
                            <div className="">
                                <p className='fw-bold py-3 darkcolorrr'>{cardData.top}</p>
                                {cardData.topPlaces.map((place, index) => (
                                    <div key={index} className="">
                                        <div
                                            style={{
                                                cursor: 'pointer',
                                                padding: '10px',
                                                marginBottom: '7px',
                                                borderRadius: '8px',
                                                transition: 'transform 0.2s'
                                            }}

                                        >
                                            <h4 className="mb-1 darkcolorrr">{place.title}</h4>
                                            <p className="mb-0">{place.description}</p>
                                        </div>
                                    </div>
                                ))}
                            </div>
                            <div
                                style={{
                                    cursor: 'pointer',
                                    padding: '10px',
                                    marginBottom: '7px',
                                    borderRadius: '8px', // Optional: rounded corners
                                    transition: 'transform 0.2s' // Optional: smooth scaling effect
                                }}
                            >
                                {cardData.services.map((service, index) => (
                                    <div key={index} className=" my-4">
                                        <h4 className="py-1 darkcolorrr">{service.name}</h4>
                                        <p>{service.description}</p>
                                    </div>
                                ))}
                            </div>

                            <table className="table table-responsive Border-key my-2">
                                <tbody className=' Border-key'>
                                    {cardData.tableData.map((row, rowIndex) => (
                                        <tr className='Border-key ' key={rowIndex}>
                                            {row.map((cell, cellIndex) => (
                                                <td key={cellIndex} className=' Border-key bluecolor fw-bold' >{cell}</td>
                                            ))}
                                        </tr>
                                    ))}
                                </tbody>
                            </table>
                            <h3 className='pt-md-3'>{cardData.keyword + " Rates"}</h3>
                            <BusRatesTable />

                            <div id="why-choose-section"
                                className='px-2'>
                                  <h2 className='whycolor py-3'>Why Choose us for  {cardData.keyword}</h2>
                                {cardData.whychoose.map((item, index) => (
                                    <div key={index}>
                                        <h4 className="py-1 whycolor">{item.WhyChooseheading}</h4>
                                        <p>{item.WhyChoosedescription}</p>
                                    </div>
                                ))}
                            </div>


                            <div className="row twm-faq-section-1 m-b30">


                                <div className=" col-md-12 wow fadeInDown" data-wow-delay="0.2">
                                    <div className="twm-faq-info-wrap">

                                        <div className="section-head left">
                                            <h2 className="twm-large-title site-text-dark darkcolor">FAQS {cardData.keyword} For S9 Travels</h2>
                                        </div>


                                        <div className="twm-faq-info">
                                            <div className="accordion twm-acdn" id="sf-faq-accordion">
                                            <FAQKeyword  faqs={faqData} />

                                                {/* <FAQKeyword faqData={faqData} /> */}
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>

                            <Testimonials testimonials={testimonialsData} />
                         

                            <div className='py-4'>

                                <div className="contact-box Borderr">
                                    <h3>{contactData.heading}</h3>
                                    <p className='text-black'>For booking inquiries or any assistance, please feel free to contact us:</p>
                                    <div className="contact-details">
                                        <p><strong className='darkcolor'>Mobile No:</strong></p>
                                        <ul>
                                            {contactData.contactNumbers.map((number, index) => (
                                                <li key={index}>
                                                    <a href={`tel:${number}`} className="contact-link fw-bold fs-5">
                                                        {number}
                                                    </a>
                                                </li>
                                            ))}
                                        </ul>
                                        <p><strong className='darkcolor'>Email Id: </strong>
                                            <a href={`mailto:${contactData.email}`} className="contact-link">
                                                {contactData.email}
                                            </a>
                                        </p>
                                    </div>
                                </div>
                            </div>
                        </div>

                        <div className='col-12 col-md-4' >
                            {Images.map((e) => {
                                return (
                                    <div className="box1">
                                        <a
                                            href="./"
                                            className="d-flex justify-content-around align-items-center"
                                        >
                                            <div className="b1">
                                                <img src={e.place} alt="img" />
                                            </div>
                                            <div className="b2">
                                                {" "}
                                                <a href="./" className='px-3'>{e.text}</a>
                                            </div>
                                        </a>
                                    </div>
                                );
                            })}


                            <div className="gallery-container">
                                <h2 className="gallery-title">Our Fleets</h2>
                                <div className="gallery-row d-flex flex-wrap">
                                    {images.map((image, index) => (
                                        <div className="gallery-item col-md-4" key={index}>
                                            <img
                                                src={image.src}
                                                alt={image.alt}
                                                className="gallery-image"

                                            />
                                        </div>
                                    ))}

                                </div>
                            </div>

                            <div className=" rounded p-4 shadow-sm Uni_border "
                                style={{
                                    cursor: 'pointer',
                                    padding: '10px',
                                    border: '3px dotted #252E5B',
                                    marginBottom: '7px',
                                    fontWeight: 'bold',
                                }}

                            >
                                <h4 className="pb-3 pt-3 lead fw-bold text-dark">Contact Information</h4>

                                <div className="row">

                                    <div className="col-12 mb-3">
                                        <div className="Small_border  rounded text-center py-2 " style={{ backgroundColor: '#252E5B' }}>
                                            <h4 className=" lead fw-semibold whitt text-darkk">Phone Numbers</h4>
                                            <i className="bi bi-telephone-fill fs-1 mb-2"></i>
                                            <div className=''>
                                                <a href="tel:+918850328441" className="d-block  text-white">+91 8850328441</a>
                                                <a href="tel:+919552526916" className="d-block  text-white">+91 9552526916</a>
                                                


                                            </div>
                                        </div>
                                    </div>


                                    <div className="col-12 mb-3 ">
                                        <div className="Small_border rounded text-center">
                                            <i className="bi bi-envelope fs-1 mb-2"></i>
                                            <div className='rounded py-2' style={{ backgroundColor: '#252E5B' }}>
                                                <h4 className=" fw-semibold lead whitt text-darkk">Email</h4>
                                                <a href="mailto:booking@s9travels.com" className=" text-white d-block">
                                                    booking@s9travels.com
                                                </a>
                                            </div>
                                        </div>
                                    </div>


                                    <div className="col-12 mb-3 ">
                                        <div className="Small_border  rounded text-center">
                                            <i className="bi bi-house-fill fs-1 mb-2"></i>
                                            <div className='rounded py-2' style={{ backgroundColor: '#252E5B' }}>
                                                <h4 className=" fw-semibold lead whitt text-darkk">Address</h4>
                                                <p className="whit text-white ">
                                                    <i> S9 Travels <br/>
                                                    Khandesh Nagar, Ghandharva Nagri, Moshi,Pune, pin-412105
                                                    </i>
                                                </p>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>



                        </div>
                    </div>
                </div>
            </section>



        </div>
    );
}

export default Bookpunetoratnagiricab;